import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import ModalUploadProgress from "@components/ModalUploadProgress";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import { EModalUploadProgress } from "@enums/modalUploadProgress";
import getModuleName from "@helpers/modules";
import useUpdateItem from "@hooks/Shared/useUpdateItem";
import { ElementType, ReactElement } from "react";
import { Form } from "react-final-form";
import { useLocation, useParams } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { THookUpdate } from "types/Shared/hooks";

interface IModify {
  CustomForm: ElementType;
  modifyHook: THookUpdate;
  detailHook: (uuid: string) => any;
  validator: (FormValues: Record<string, any>) => any;
  formMapper: (FormValues: any) => any;
}

const Modify = ({
  CustomForm,
  modifyHook,
  detailHook,
  validator,
  formMapper,
}: IModify): ReactElement => {
  const { uuid } = useParams<{ uuid: string }>();
  const { data, loading } = detailHook(uuid);
  const { pathname } = useLocation();
  const {
    isUpdating,
    isModalOpen,
    handleSaveForm,
    handleUpdate,
    handleIsModalOpen,
    totalFiles,
    totalSize,
    uploadedFiles,
    uploadedSize,
    isProgressOpen,
  } = useUpdateItem();

  return (
    <Container>
      <ModalConfirmation
        icon="plus-circle"
        title={`${getModuleName(pathname)} | Modify confirmation`}
        body={"Are you sure you want to update the item?"}
        handleConfirm={() => {
          handleUpdate(modifyHook, uuid);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.WARNING}
      />

      <ModalUploadProgress
        modalStatus={isProgressOpen}
        modalType={EUiStates.WARNING}
        status={EModalUploadProgress.UploadInProgress}
        uploadedFiles={uploadedFiles}
        totalFiles={totalFiles}
        uploadedSize={uploadedSize}
        totalSize={totalSize}
      />

      <Title />
      <Row>
        <Col xs={12} md={12} lg={12} xl={10}>
          <Card>
            <CardBody>
              <Form
                onSubmit={(FormValues) => {
                  handleSaveForm(FormValues, formMapper);
                }}
                validate={validator}
              >
                {({ handleSubmit, form }) =>
                  isUpdating || loading ? (
                    <Loader isInsideThing />
                  ) : (
                    <CustomForm
                      handleSubmit={handleSubmit}
                      form={form}
                      data={data}
                    />
                  )
                }
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Modify;
